import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { useI18n } from "../contexts/I18nContext";
import { LayoutDashboard, Users, Receipt, FileText, ShieldCheck } from "lucide-react";

export default function AdminLayout() {
  const { t } = useI18n();

  const items = [
    { to: "/admin", end: true, icon: LayoutDashboard, label: t("admin_nav_dashboard") },
    { to: "/admin/users", icon: Users, label: t("admin_nav_users") },
    { to: "/admin/invoices", icon: Receipt, label: t("admin_nav_invoices") },
    { to: "/admin/policies", icon: FileText, label: t("admin_nav_policies") },
  ];

  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-3.5 py-2.5 rounded-xl text-sm font-medium transition-colors ${
      isActive ? "bg-zinc-900 text-white" : "text-zinc-700 hover:bg-zinc-900/5"
    }`;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center gap-3 mb-8">
        <span className="w-9 h-9 rounded-xl bg-zinc-900 grid place-items-center">
          <ShieldCheck className="w-5 h-5 text-white" strokeWidth={1.8} />
        </span>
        <div>
          <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight" data-testid="admin-title">
            {t("admin_title")}
          </h1>
          <p className="text-xs text-zinc-500">{t("admin_subtitle")}</p>
        </div>
      </div>

      <div className="grid lg:grid-cols-12 gap-6">
        <aside className="lg:col-span-3">
          <nav className="surface-card p-2 lg:sticky lg:top-24 space-y-1" data-testid="admin-sidebar">
            {items.map((it) => {
              const Icon = it.icon;
              return (
                <NavLink key={it.to} to={it.to} end={it.end} className={linkClass} data-testid={`admin-nav-${it.to.split("/").pop() || "home"}`}>
                  <Icon className="w-4 h-4" strokeWidth={2} />
                  <span>{it.label}</span>
                </NavLink>
              );
            })}
          </nav>
        </aside>

        <main className="lg:col-span-9">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
